import { createTheme } from '@mui/material/styles';

import { withMobileComponents } from './mobileOverrides';

export const theme = createTheme({
  components: withMobileComponents(),
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#ff9800' },
    background: { default: '#f5f5f5' },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    // Fluid type: scales smoothly from 320 px viewport up to 1280 px.
    // clamp(min, preferred, max) — preferred uses vw so font tracks viewport,
    // floor + ceiling guarantee legibility on tiny phones and prevent giant
    // type on wide displays.
    h1: { fontSize: 'clamp(1.5rem, 1.2rem + 1.5vw, 2rem)', fontWeight: 600, lineHeight: 1.25 },
    h2: { fontSize: 'clamp(1.2rem, 1rem + 1vw, 1.5rem)', fontWeight: 600, lineHeight: 1.3 },
    h3: { fontSize: 'clamp(1rem, 0.95rem + 0.4vw, 1.125rem)', fontWeight: 600, lineHeight: 1.4 },
    h4: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
    h5: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: '0.875rem', fontWeight: 600, lineHeight: 1.4 },
    body1: { fontSize: 'clamp(0.9375rem, 0.9rem + 0.15vw, 1rem)' },
  },
  shape: { borderRadius: 8 },
});
